import { UseFormReturn, FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  styles?: React.CSSProperties;
};

export default function FormProvider({ children, onSubmit, methods ,styles}: Props) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} style={styles}>{children}</form>
    </Form>
  );
}
